export const CLIENTS_SUMMARY_DASHBOARD_FETCH_FAILED = 'CLIENTS_SUMMARY_DASHBOARD_FETCH_FAILED';
export const CLIENTS_SUMMARY_DASHBOARD = 'CLIENTS_SUMMARY_DASHBOARD';
export const SET_LICENSED_MARKETS = 'SET_LICENSED_MARKETS';
export const SET_LICENSED_STATES = 'SET_LICENSED_STATES';
export const SET_VISITOR_ORIGIN_PAGE = 'SET_VISITOR_ORIGIN_PAGE';
export const LENGTH_OF_ARTICLE = 'LENGTH_OF_ARTICLE';
export const SET_TAGS = 'SET_TAGS';
export const SET_BROKER_TYPE = 'SET_BROKER_TYPE';
export const SET_CAMPAIGN_ADMIN_POPUP = 'SET_CAMPAIGN_ADMIN_POPUP';
export const FETCH_CAMPAIGNADMIN_SIGNFORMS_DATA = 'FETCH_CAMPAIGNADMIN_SIGNFORMS_DATA';
export const SET_PRODUCER_SPECIALIZATION = 'SET_PRODUCER_SPECIALIZATION';
export const FETCH_CAMPAIGNADMIN_POPUPMESSAGE_DATA = 'FETCH_CAMPAIGNADMIN_POPUPMESSAGE_DATA';
export const FETCH_CAMPAIGN_AUTOPUSH_POPUP = 'FETCH_CAMPAIGN_AUTOPUSH_POPUP';
export const UPDATE_CAMPAIGN_AUTOPUSH_POPUP = 'UPDATE_CAMPAIGN_AUTOPUSH_POPUP'; 
